import { Link } from 'react-router-dom';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import { ReactComponent as ArrowCircle } from 'images/Icons/ArrowCircle.svg';

import styles from 'components/UI/ArrowCircleLink/ArrowCircleLink.module.scss';

const ArrowCircleLink = ({ title, path, direction = 'right', className }) => (
  <Link
    to={path}
    className={classNames(styles.link, styles[direction], className)}
    data-testid="arrow-circle-link-root"
  >
    {title}
    <ArrowCircle className={styles.icon} data-testid="arrow-circle-link-icon" />
  </Link>
);

ArrowCircleLink.propTypes = {
  title: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  direction: PropTypes.oneOf(['right', 'left']),
  className: PropTypes.string,
};

export default ArrowCircleLink;
